// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	OwnerResidesAtSubjectPropertyCheckbox:
		'owner-resides-at-subject-property-checkbox',
	OwnerResidesAtPropertyMoveoutDatePicker:
		'owner-resides-at-property-moveout-date-picker',
	TenantedCheckbox: 'tenanted-checkbox',
	MultiUnitCheckbox: 'multi-unit-checkbox',
	SubjectPropertyIsPOTLCheckbox: 'subject-property-is-potl-checkbox',
	ParcelOfTiedLandForm: 'parcel-of-tied-land-form',
	UsageRadioGroup: 'usage-radio-group',
	ConditionRadioGroup: 'condition-radio-group',
	UnitTypeRadioGroup: 'unit-type-radio-group',
	NumberOfUnitsRadioGroup: 'number-of-units-radio-group',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
